import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const restaurantDetailsStore = {
    actionCreators,
    reducer,
};

export default restaurantDetailsStore;
